import { PowerUp } from "./PowerUp";
import { RectangleWithRadius } from "../utils/RectangleWithRadius";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { PauseMenu } from "../GUI/PauseMenu";
import { GameManager } from "../GameManager";
import { PreMatchLayer } from "./match-scene/PreMatchLayer";

export class PowerUpsContainer extends Phaser.Group {

    public isPreMatchLayer: boolean;
    public creditsLabel: Phaser.Text;
    public freezeGoalKeeperPowerUp: PowerUp;
    public extraBallsPowerUp: PowerUp;
    public ballOfFirePowerUp: PowerUp;
    public voodooPowerUp: PowerUp;


    constructor(game: Phaser.Game, isPreMatchLayer: boolean) {

        super(game, null, "powerups-container", false);

        this.isPreMatchLayer = isPreMatchLayer;
 
        let bottomRectangleWithRadius = new RectangleWithRadius(this.game, 20 , 0, GameConstants.GAME_WIDTH - 40, 350 , 40, "#2B3536", 0.5, RectangleWithRadius.BOTTOM_CONFIGURATION);
        this.add(bottomRectangleWithRadius);

        this.addCredits();
        this.addDescriptionLabels();
        this.addPowerUps();
    }

    public updateContainer(): void {

        const creditsString = GameVars.formatNumber(GameVars.gameData.credits);

        this.creditsLabel.text = creditsString;
        this.creditsLabel.x = GameConstants.GAME_WIDTH / 2;

        this.freezeGoalKeeperPowerUp.updatePowerUp();
        this.extraBallsPowerUp.updatePowerUp();
        this.ballOfFirePowerUp.updatePowerUp();
        this.voodooPowerUp.updatePowerUp();

        // si es el de prematch hacer update en el del menu de pausa
        if (this.isPreMatchLayer) {
            PauseMenu.currentInstance.powerUpsContainer.updateContainer();
        }
    }

    public giveReward(): void {

        GameVars.gameData.credits += 1000;
        GameManager.writeGameStorage();

        this.freezeGoalKeeperPowerUp.updatePowerUp();
        this.extraBallsPowerUp.updatePowerUp();
        this.ballOfFirePowerUp.updatePowerUp();
        this.voodooPowerUp.updatePowerUp();

        const tweenUp = this.game.add.tween(this.creditsLabel.scale).to({ x: 1.15, y: 1.15 }, 350, Phaser.Easing.Cubic.Out, true, 500);
        tweenUp.onStart.add(function(): void {

            this.creditsLabel.setText(GameVars.formatNumber(GameVars.gameData.credits));

            PreMatchLayer.currentInstance.playButton.visible = true;
            PreMatchLayer.currentInstance.levelSelectionButton.visible = true;

        }, this);
        const tweenDown = this.game.add.tween(this.creditsLabel.scale).to({ x: 1, y: 1 }, 350, Phaser.Easing.Cubic.Out);
        tweenUp.chain(tweenDown);
        tweenUp.start();
    }

    private addCredits(): void {

        const creditsCartridgeImage = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 6 , "texture_atlas_5", "credits_cartridge" );
        creditsCartridgeImage.anchor.setTo(.5, 0);
        this.add(creditsCartridgeImage);

        const creditsString = GameVars.formatNumber(GameVars.gameData.credits);

        this.creditsLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 38, creditsString, { font: "36px Ubuntu", fontWeight: "700", fill: "#FFD51B", align: "center"});
        this.creditsLabel.anchor.set(.5);
        this.add(this.creditsLabel);
    }

    private addDescriptionLabels(): void {

        let descriptionLabel = new Phaser.Text(this.game, 120, 233,
            "FREEZE THE GOALKEEPER 1 TURN" , { font: "17px Arial", fill: "#ffffff", align: "center", wordWrap: true, wordWrapWidth: 180} );
        descriptionLabel.anchor.x = .5;
        this.add(descriptionLabel);

        descriptionLabel = new Phaser.Text(this.game, 300, 233,
            "GET 3 EXTRA BALLS" , { font: "17px Arial", fill: "#ffffff", align: "center", wordWrap: true, wordWrapWidth: 180} );
        descriptionLabel.anchor.x = .5;
        this.add(descriptionLabel);

        descriptionLabel = new Phaser.Text(this.game, 490, 233,
            "BURN ALL OBSTACLES" , { font: "17px Arial", fill: "#ffffff", align: "center", wordWrap: true, wordWrapWidth: 180} );
        descriptionLabel.anchor.x = .5;
        this.add(descriptionLabel);

        descriptionLabel = new Phaser.Text(this.game, 660, 233,
            "ELIMINATE ALL RIVALS ON THE FIELD" , { font: "17px Arial", fill: "#ffffff", align: "center", wordWrap: true, wordWrapWidth: 180} );
        descriptionLabel.anchor.x = .5;
        this.add(descriptionLabel);
    }

    private addPowerUps(): void {

        this.freezeGoalKeeperPowerUp = new PowerUp(this.game, GameConstants.FREEZE_GOALKEEPER);
        this.freezeGoalKeeperPowerUp.powerUpsContainer = this;
        this.freezeGoalKeeperPowerUp.x = 12;
        this.freezeGoalKeeperPowerUp.y = 85;
        this.add( this.freezeGoalKeeperPowerUp);

        this.extraBallsPowerUp = new PowerUp(this.game, GameConstants.EXTRA_BALLS);
        this.extraBallsPowerUp.powerUpsContainer = this;
        this.extraBallsPowerUp.x = 196;
        this.extraBallsPowerUp.y = 85;
        this.add( this.extraBallsPowerUp);

        this.ballOfFirePowerUp = new PowerUp(this.game, GameConstants.BALL_OF_FIRE);
        this.ballOfFirePowerUp.powerUpsContainer = this;
        this.ballOfFirePowerUp.x = 380;
        this.ballOfFirePowerUp.y = 85;
        this.add(this.ballOfFirePowerUp);

        this.voodooPowerUp = new PowerUp(this.game, GameConstants.VOODOO);
        this.voodooPowerUp.powerUpsContainer = this;
        this.voodooPowerUp.x = 562;
        this.voodooPowerUp.y = 85;
        this.add(this.voodooPowerUp);
    }
}
